import { FormErrorMessage as ChakraFormErrorMessage } from '@chakra-ui/react';

type FormErrorMessageProps = React.ComponentProps<
  typeof ChakraFormErrorMessage
>;

const FormErrorMessage = ({
  children,
  ...props
}: Readonly<FormErrorMessageProps>) => {
  return <ChakraFormErrorMessage {...props}>{children}</ChakraFormErrorMessage>;
};

export default FormErrorMessage;
